module.exports = __webpack_public_path__ + "static/LOGOVERT-PERSONNAGE-a91783ebb92ed159f6573881a31b3b9e.svg";